import { useEffect, useState } from "react";
import axios from "axios";
import { API, getAuthToken } from "@/App";

const FALLBACK = [
  "Regional Discount",
  "Brand Penetration",
  "Quarterly Scheme Adjustment",
  "Freebie Adjustment",
  "Compensation / Replacement",
  "Liquidation / Stock Clearance",
  "Multi-Brand Pricing Difference",
  "Logistics Adjustment",
  "Others",
];

let CACHE = null;

// Tiny shared fetch for remark categories. Falls back to the hard-coded list if the API is
// unreachable so the page never breaks. Cached for the session.
export function useRemarkCategories() {
  const [categories, setCategories] = useState(CACHE || FALLBACK);

  useEffect(() => {
    if (CACHE) return;
    let cancelled = false;
    axios
      .get(`${API}/remark-categories`, { headers: { Authorization: `Bearer ${getAuthToken()}` } })
      .then((res) => {
        if (cancelled) return;
        const list = Array.isArray(res?.data?.categories) ? res.data.categories : FALLBACK;
        CACHE = list;
        setCategories(list);
      })
      .catch(() => { /* swallow: keep fallback */ });
    return () => { cancelled = true; };
  }, []);

  return categories;
}
